var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgValidationError = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7852 2.96484C13.1159 4.27734 13.7812 5.8724 13.7812 7.75C13.7812 9.6276 13.1159 11.2318 11.7852 12.5625C10.4727 13.875 8.8776 14.5312 7 14.5312C5.1224 14.5312 3.51823 13.875 2.1875 12.5625C0.875 11.2318 0.21875 9.6276 0.21875 7.75C0.21875 5.8724 0.875 4.27734 2.1875 2.96484C3.51823 1.63411 5.1224 0.96875 7 0.96875C8.8776 0.96875 10.4727 1.63411 11.7852 2.96484ZM7.875 9.5C7.63802 9.24479 7.34635 9.11719 7 9.11719C6.65365 9.11719 6.35286 9.24479 6.09766 9.5C5.86068 9.73698 5.74219 10.0286 5.74219 10.375C5.74219 10.7214 5.86068 11.0221 6.09766 11.2773C6.35286 11.5143 6.65365 11.6328 7 11.6328C7.34635 11.6328 7.63802 11.5143 7.875 11.2773C8.13021 11.0221 8.25781 10.7214 8.25781 10.375C8.25781 10.0286 8.13021 9.73698 7.875 9.5ZM5.79688 4.60547L6.01562 8.32422C6.01562 8.52474 6.125 8.625 6.34375 8.625H7.65625C7.875 8.625 7.98438 8.52474 7.98438 8.32422L8.20312 4.60547C8.20312 4.49609 8.16667 4.41406 8.09375 4.35938C8.03906 4.28646 7.96615 4.25 7.875 4.25H6.125C6.03385 4.25 5.95182 4.28646 5.87891 4.35938C5.82422 4.41406 5.79688 4.49609 5.79688 4.60547Z",
    fill: "#C6176E"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgValidationError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/validationError.c214b31e.svg";
export { ForwardRef as ReactComponent };